// -----------------------------------------------------------------------------
// Nachrichten
// -----------------------------------------------------------------------------

import * as generalUtility from '../utility/generalUtility';

const init = () => {
  if ($('.js-body').hasClass('js-body-messages') === false) {
    return;
  }

  initEventListeners();
};

/**
 * Event-Listeners einrichten
 */
const initEventListeners = () => {
  const basepath = $('.js-body').attr('data-basepath');
  const vars = generalUtility.getJsonFromHtml('.js-body-messages #vars');
  const trans = generalUtility.getJsonFromHtml('.js-body-messages #trans');
  const $msgHistory = $('.msg_history');
  let actUSRID = 0;

  $('.loadChat').click(function (e) {
    e.preventDefault();

    // Ausgewählten Chat highlighten
    $('.chat_list').removeClass('active_chat');
    $(this).parent().addClass('active_chat');
    actUSRID = $(this).data('id');
    $msgHistory.load(`${basepath}/messages/get/${actUSRID}`, {limit: 25}, function () {
      $msgHistory.scrollTop($msgHistory[0].scrollHeight);
    });
  });

  $('.write_msg').keypress(function (event) {
    if (event.which === 13) {
      const value = $(this).val();
      $msgHistory.append(`<div class="outgoing_msg"><div class="sent_msg"><p>${value}</p><span class="time_date">${trans.soeben}</span></div>`);
      $.ajax({
        url: vars.LNKsendmsg,
        method: 'POST',
        data: {
          id: actUSRID,
          text: $(this).val()}
      });

      $(this).val('');
      $msgHistory.scrollTop($msgHistory[0].scrollHeight);
    }
  });
};

export {
  init
};
